import React, { useState, useEffect, useRef } from 'react';

import { Translate } from '@hydra/common/components';

const useLoadPerfCascade = () => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [perfCascade, setPerfCascade] = useState();

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const [perfCascade] = await Promise.all([
          import('perf-cascade/dist/perf-cascade'),
          import('perf-cascade/dist/perf-cascade.css')
        ]);
        setPerfCascade(perfCascade);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return {
    error,
    loading,
    perfCascade
  };
};

const LoadingErrorMessage = ({ error, loading }) => {
  return (
    <>
      {loading && <Translate content='loading' />}
      {error && <Translate content='generic_error' />}
    </>
  );
};

export const Legend = () => {
  const { error, loading, perfCascade } = useLoadPerfCascade();
  const ref = useRef();

  useEffect(() => {
    if (!perfCascade) {
      return;
    }
    const container = ref.current;
    const legend = perfCascade.makeLegend();
    container.append(legend);
    return () => container.removeChild(legend);
  }, [perfCascade]);

  return (
    <div ref={ref}>
      <LoadingErrorMessage error={error} loading={loading} />
    </div>
  );
};

export default ({ doc }) => {
  const { error, loading, perfCascade } = useLoadPerfCascade();
  const ref = useRef();

  useEffect(() => {
    if (!perfCascade) {
      return;
    }
    const container = ref.current;
    const svg = perfCascade.fromHar(doc);
    container.append(svg);
    return () => container.removeChild(svg);
  }, [perfCascade, doc]);

  return (
    <div ref={ref}>
      <LoadingErrorMessage error={error} loading={loading} />
    </div>
  );
};
